<template>
  <div class="content">
    <div class="container-fluid p-0 col-6">
      <card>
        <h4 slot="header" class="card-title">Detail uživatelské role</h4>
        <form>
          <div class="row">
            <div class="col-12">
              <base-input type="text" label="Název" v-model="userRoleObject.Name" />
              <div v-if="submitted && !$v.userRoleObject.Name.required" class="invalid-feedback d-block">Název je povinný</div>
            </div>
          </div>

          <label>Oprávnění</label>
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Název</th>
                    <th>Povoleno</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(permission, index) in userPermissions" :value="permission.Id" :key="permission.Id">
                    <td>{{permission.Name}}</td>
                    <td class="justify-content-center">
                      <div class="custom-control custom-checkbox" v-if="dataLoaded">
                          <input type="checkbox" class="custom-control-input" :id="'chb' + permission.Id" v-model="userRolePermissions[index].Enabled"
                              :checked="userRolePermissions[index] !== undefined ? userRolePermissions[index].Enabled : false">
                          <label class="custom-control-label" :for="'chb' + permission.Id"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <hr>
          <div class="text-center">
            <button type="submit" class="btn btn-success btn-fill float-right" @click.prevent="saveData">
              Uložit
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
  import Card from '@/components/Cards/Card.vue';
  import dataService from '@/services/dataService.js';
  import vueFormHelper from '@/js/VueFormHelper.js';
  import { required } from "vuelidate/lib/validators";

  export default {
    components: {
      Card
    },
    methods: {
      async saveData() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
        let roleId = await JSON.parse(await dataService.upsert($TablesEnum.userRole, this.userRoleObject)).Id;

        if (this.newForm) {
          this.userRolePermissions.forEach(userRolePermission => {
            userRolePermission.RoleId = roleId;
          });
        }

        await dataService.saveRolePermissions(this.userRolePermissions);
        this.$router.push('/users');
      }
    },
    created: async function () {
      if (this.$route.query.newForm !== undefined)
        this.newForm = this.$route.query.newForm;
      if ((this.newForm != undefined) && (!this.newForm))
        this.userRoleObject = this.$route.query.objectData;

      this.userRoles = await JSON.parse(await dataService.getAllUserRoles(['Id', 'Name']));
      this.userPermissions = await JSON.parse(await dataService.getAllUserPermissions(['Id', 'Name']));
      this.userRolePermissions = await JSON.parse(await dataService.getAllUserRolePermissions(undefined, {RoleId: this.userRoleObject.Id}));

      if (this.userRolePermissions == '') {
        this.userPermissions.forEach(userPermission => {
          this.userRolePermissions.push({RoleId: -1, PermissionId: userPermission.Id, Enabled: false});
        });
      }

      this.dataLoaded = true;
    },
    data () {
      return {
        dataLoaded: false,
        submitted: false,
        newForm: true,
        userRoles: [],
        userPermissions: [],
        userRolePermissions: [],
        userRoleObject: {
          Id: -1,
          Name: null,
          Description: null
        }
      }
    },
    validations: {
      userRoleObject: {
        Name: { required }
      }
    }
  }
</script>